import { useRowSelect } from '@table-library/react-table-library/select';
import { Action, State } from '@table-library/react-table-library/types/common';
import { Button, Label, TableItem } from 'components/atoms';
import Table from 'components/organisms/table/Table';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarPage } from 'components/templates';
import { threadsItemCount } from 'constants/pageSizes';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiChatCircleText, PiCheck, PiPlus } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetThreads } from 'services/chat';
import { THREAD_STATUS } from 'services/chat/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { formatMessageDate } from 'utils/global/date.utils';
import { getPlainText } from 'utils/global/plainText.utils';

const LabelThreads = () => {
  const labelId = useCustomParamId('id', '/label');
  const { t } = useTranslation();
  const threads = useGetThreads({ labelId, itemCount: threadsItemCount });
  const navigate = useNavigate();

  const nodes =
    threads.data?.pages.flat().map(t => ({
      ...t,
      id: t.messageThreadId,
    })) ?? [];

  const onSelectChange = (action: Action, state: State) => {
    navigate(`/label/${labelId}/threads/${action?.payload.id}`);
  };

  const select = useRowSelect(
    { nodes },
    {
      onChange: onSelectChange,
    },
  );

  return (
    <TopbarPage
      topbar={
        <TopBar
          size='compact'
          useHelmet={false}
          hideHeader
          customBackItem={<div className='none' />}
          topbarContent={
            <Button
              onlyIcon
              variant={BUTTON_VARIANT.submit}
              onClick={() => navigate('create')}>
                            <Button.Description description={t('button.add')} />

                            <Button.Icon icon={<PiPlus />} />
            </Button>
          }
        />
      }>
      <Table
        id={'label-threads'}
        size='compact'
        select={select}
        data={{
          nodes: nodes,
        }}
        columns={[
          {
            label: t('input.label.subject'),
            renderCell: thread => (
              <TableItem>
                <TableItem.Text text={thread.subject} />
                <TableItem.Text
                  isSupplementary
                  text={`${formatMessageDate(thread.lastMessage.messageCreatedAt)} - ${getPlainText(thread.lastMessage.body)}`}
                />
              </TableItem>
            ),
          },
          {
            label: '',
            renderCell: thread => (
              <TableItem justifyPosition='end'>
                <div className='flex gap-4'>
                  {thread.hasUnreadMessage && (
                    <Label color='blue'>
                      <PiChatCircleText />
                    </Label>
                  )}
                  {thread.messageThreadStatus.id === THREAD_STATUS.closed && (
                    <Label color='gray'>
                      <PiCheck />
                    </Label>
                  )}
                </div>
              </TableItem>
            ),
          },
        ]}
      />
    </TopbarPage>
  );
};

export default LabelThreads;
